import { render, staticRenderFns } from "./HomeFeedAssessment.vue?vue&type=template&id=0e50c5a7&scoped=true"
import script from "./HomeFeedAssessment.vue?vue&type=script&lang=js"
export * from "./HomeFeedAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e50c5a7",
  null
  
)

export default component.exports